import { Dayjs } from "dayjs";
import { PaymentLineItem } from "./PaymentLineItem";
import { Purchase } from "./Purchase";
import { Transaction } from "./Transaction";

export interface Gratuity {
    id: ID;
    amount: number;
    comment: string;
    object: string;
    status: GratuityStatus;
    createdAt: Dayjs;
    references: GratuityReference[];
    payment: PaymentLineItem;
    transaction: Transaction;
    createdBy: { id: ID };
    traveler: { id: ID };
}

export interface GratuityReference {
    id: ID;
    title: string;
    actualStart: Dayjs;
    start: Dayjs;
    end: Dayjs;
    experience: { id: ID };
    object: ReferenceObject;
    open: number;
    purchase: Purchase[];
    private: boolean;
    name?: string;
}

export enum GratuityStatus {
    PENDING = "pending",
    RECONCILED = "reconciled",
}

export enum ReferenceObject {
    EVENT = "event",
    USER_PROFILE = "user_profile",
    PURCHASE_ITEM = "scheduled_experience_purchase_item",
}

export const GratuityObject = "gratuity";
